export const tenantActionTypes = {
  SET_TENANT_ERROR: 'SET_TENANT_ERROR',
  CLEAR_TENANT_ERROR: 'CLEAR_TENANT_ERROR'
};
